export default "__VITE_ASSET__9c55d273__"